import { callApi } from './api';

export const updateSupportPlanDraftStatus = async (
  supportPlanDraftID: number,
  supportPlanDraftStatus: string
) => {
  const { status, result } = await callApi<boolean>(
    `support-plan-drafts/${supportPlanDraftID}`,
    'PATCH',
    undefined,
    { status: supportPlanDraftStatus },
    undefined,
    undefined,
    true
  );
  return { status, result };
};
